import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { ListEditModeType, ListItemType } from '../../types';
import { hashingData } from './functionSlice';

export interface IListItemState {
    items: ListItemType[];
    originalItems: ListItemType[];
    parent: string;
    currentItemId: number | null;
    currentItem: ListItemType | null;
    currentEditItem: ListItemType | null;
    parentItem: ListItemType | null;
    parentDynamicItem: any;
    editMode: ListEditModeType;
    childIdEdit: number;
    spinner: boolean;
    typeList: 'local' | 'remote';
    messageError: string;
    connectionId: string;
    connectionParentId: string;
    updateFetchKey: number;
}

const initialState: IListItemState = {
    items: [],
    originalItems: [],
    parent: '',
    currentItemId: null,
    currentItem: null,
    currentEditItem: null,
    parentItem: null,
    parentDynamicItem: null,
    editMode: 'viewing',
    childIdEdit: 0,
    spinner: false,
    typeList: 'local',
    messageError: '',
    connectionId: '',
    connectionParentId: '',
    updateFetchKey: 0,
};

const slices: { [key: string]: any } = {};

const storeHash: { [keySlice: string]: { [key: string]: number } } = {};

export const listItemSlice = (nameList: string) => {
    if (slices[nameList]) {
        return slices[nameList];
    }

    slices[nameList] = createSlice({
        name: 'listItem',
        initialState,
        reducers: {
            setterListItem: (state, action: PayloadAction<Partial<IListItemState>>) => {
                if (!storeHash[nameList]) {
                    storeHash[nameList] = {};
                }

                hashingData(storeHash[nameList], action.payload, 'items');
                hashingData(storeHash[nameList], action.payload, 'originalItems');

                if (!Object.keys(action.payload).length) {
                    return state;
                }

                return {
                    ...state,
                    ...action.payload,
                };
            },
            changeUpdateFetchKey: (state) => {
                return {
                    ...state,
                    updateFetchKey: state.updateFetchKey + 1,
                };
            },
        },
    });

    return slices[nameList];
};

export const getSetterListItem = (nameList: string) => listItemSlice(nameList).actions.setterListItem;
export const getChangeUpdateFetchKey = (nameList: string) => listItemSlice(nameList).actions.changeUpdateFetchKey;

export const getListItemSlice = (nameList: string) => listItemSlice(nameList).reducer;
